import { useQuery } from "@apollo/react-hooks";

import { Arrears, ArrearsDetailInput } from "@hubcapp/types";

import GetInstructorArrearsBreakdown from "../graph-ql/getInstructorArrearsBreakdown.graphql";

const useQueryInstructorArrearsBreakdown = (input: ArrearsDetailInput) =>
  useQuery<{
    getArrearsDetailForProposition: Arrears[];
  }>(GetInstructorArrearsBreakdown, {
    variables: {
      input,
    },
  });

export default useQueryInstructorArrearsBreakdown;
